const FILES_BASE = `${process.env.REACT_APP_BACKEND_URL}/api/files`;

export const BRAND = {
  board: `${FILES_BASE}/gratiora/brand/board.webp`,
  wedding: `${FILES_BASE}/gratiora/brand/wedding.webp`,
  navy: `${FILES_BASE}/gratiora/brand/navy-kit.webp`,
  elephant: `${FILES_BASE}/gratiora/products/elephant-trunk.webp`,
};

export const CATEGORIES = [
  { slug: "gourmet-confectionery", name: "Gourmet & Confectionery", image: "https://images.unsplash.com/photo-1759563871375-d5b140f6646e?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
  { slug: "tea-coffee", name: "Tea & Coffee", image: "https://images.unsplash.com/photo-1687768665882-b9affb531d8f?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
  { slug: "signature-collections", name: "Signature Collections", image: "https://images.unsplash.com/photo-1668127039849-c5dd95be3fa5?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
  { slug: "wedding-favors", name: "Wedding Favors", image: "https://images.unsplash.com/photo-1521478706270-f2e33c203d95?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
  { slug: "desk-stationery", name: "Desk & Stationery", image: "https://images.unsplash.com/photo-1751564360679-33a47cdc151d?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
  { slug: "drinkware", name: "Drinkware", image: "https://images.unsplash.com/photo-1708632911127-c12d8dc1ee8e?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
  { slug: "tech-workspace", name: "Tech & Workspace", image: "https://images.unsplash.com/photo-1644463589256-02679b9c0767?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
  { slug: "bags-travel", name: "Bags & Travel", image: "https://images.unsplash.com/photo-1525103504173-8dc1582c7430?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
  { slug: "lifestyle-welcome", name: "Lifestyle & Welcome Kits", image: "https://images.unsplash.com/photo-1674620213535-9b2a2553ef40?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1545844568-98bb15133ec0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1080",
  manifesto: "https://images.unsplash.com/photo-1774891937445-be15587e50c1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1080",
  studio: "https://images.unsplash.com/photo-1642166900939-4f6b9db890ca?crop=entropy&cs=srgb&fm=jpg&q=85&w=1080",
};

export const CORPORATE_CATEGORIES = [
  "signature-collections", "gourmet-confectionery", "tea-coffee", "desk-stationery",
  "drinkware", "tech-workspace", "bags-travel", "lifestyle-welcome",
];

export const PERSONAL_CATEGORIES = ["wedding-favors", "signature-collections", "gourmet-confectionery"];

export const categoryName = (slug) =>
  CATEGORIES.find((c) => c.slug === slug)?.name || slug;
